var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarInfoStreamax",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar General Record Streamax"
                                                : "Ver Detalle General Streamax"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.system.label,
                                          items: _vm.formFields.system.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedSystem,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.system.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.system,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.system.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.overWrite.label,
                                          items: _vm.formFields.overWrite.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedOverWrite,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.overWrite.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.overWrite,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.overWrite.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.preRecording.label
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.preRecording.check,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.preRecording,
                                              "check",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.preRecording.check"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm6: "",
                                        md6: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.preRecordingMinutes
                                              .label,
                                          items:
                                            _vm.formFields.preRecordingMinutes
                                              .items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value:
                                            _vm.selectedPreRecordingMinutes,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.preRecordingMinutes
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields
                                                .preRecordingMinutes,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.preRecordingMinutes.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }